const headers = (idSearch, employeeCodeSearch, employeeNameSearch = "", departmentNameSearch = "", divisionNameSearch = "", statusSearch = -1) => {
  return [
    { text: "Thao tác", value: "actions", width: 120, sortable: false },
    { text: 'Mã ID', value: 'id', align: 'start', sortable: true, width: 80,
      filter: value => {
        if (!idSearch) return true
        return value == idSearch
      },
    },
    { text: 'Nhân viên', value: 'employeeInfo', align: 'start', width: 220 },
    { text: 'Mã nhân viên', value: 'employeeCode', align: ' d-none',
      filter: value => {
        if (!employeeCodeSearch) return true
        return value.includes(employeeCodeSearch)
      },
    },
    { text: 'Tên nhân viên', value: 'employeeName', align: ' d-none', 
      filter: value => {
        if (!employeeNameSearch) return true
        return value.toLowerCase().includes(employeeNameSearch.toLowerCase())
      },
    },
    { text: 'Phòng ban', value: 'departmentName', align: ' d-none', 
      filter: value => {
        if (!departmentNameSearch) return true
        if (value == null) return true
        return value.toLowerCase().includes(departmentNameSearch.toLowerCase())
      },
    },
    { text: 'Bộ phận', value: 'divisionName', align: ' d-none', 
      filter: value => {
        if (!divisionNameSearch) return true
        if (value == null) return true
        return value.toLowerCase().includes(divisionNameSearch.toLowerCase())
      },
    },
    { text: 'Ngày công', value: 'workDate', width: 140 },
    { text: 'Giờ cần XN', value: 'worktime', width: 100 },
    { text: 'Giờ đã XN', value: 'confirmedWorktime', width: 110 },
    { text: 'Lý do & Diễn giải', value: 'reason', width: 250 },
    { text: 'Ghi chú', value: 'note', align: ' d-none' },
    { text: 'Hình ảnh', value: 'imageUrl', width: 80 },
    { text: 'Tiến trình duyệt', value: 'approverInfo', width: 200 },
    { text: 'Ngày tạo', value: 'createdAt', align: ' d-none' },
    { text: 'Quản lý trực tiếp', value: 'managerName', align: ' d-none' },
    { text: 'Nhân sự phụ trách', value: 'hrAdminName', align: ' d-none' },
    { text: 'Giám đốc nhân sự', value: 'hrManagerName', align: ' d-none' },
    { 
      text: 'Trạng thái', 
      value: 'confirmLevel', 
      width: 130,
      // Lọc theo trạng thái phiếu: Tất cả, Chờ duyệt, Tạo mới, QL đã duyệt, Hoàn tất, Từ chối
      filter: (value, search, item) => {
        if (statusSearch === null || statusSearch === undefined || statusSearch === -1 || statusSearch === '') return true;
        const isReject = item ? item.isReject : false;
        const level = item ? item.confirmLevel : value;
        if (statusSearch === 'pending') {
          return !isReject && level < 2;
        }
        if (statusSearch === 'reject') {
          return !!isReject;
        }
        if (statusSearch === 0) {
          return !isReject && level === 0;
        }
        if (statusSearch === 1) {
          return !isReject && level === 1;
        }
        if (statusSearch === 2) {
          return !isReject && level >= 2;
        }
        return true;
      }
    },
  ]
}
export default headers;